// src/components/legal/ConsentNotice.jsx
import React from "react";
import { Text } from "@chakra-ui/react";

export default function ConsentNotice({ mb = 0 }) {
  return (
    <Text fontSize="xs" color="gray.600" mt={2} mb={mb}>
      By clicking “Submit”, you agree this site may share your information with
      selected tax relief companies relevant to your inquiry. You authorize them
      to contact you at the email and phone number provided, including by
      text/SMS and autodialed or prerecorded calls (message/data rates may
      apply). Your consent is not a condition of purchase. You may opt out of
      texts at any time by replying STOP. See our{" "}
      <a href="/legal/privacy" style={{ textDecoration: "underline" }}>
        Privacy Policy
      </a>
      .
    </Text>
  );
}
